export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyArPCwHOhWkMDUb4R9Nk5L3jvcONwTo4VY",
    authDomain: "contadoresrv-8b2d4.firebaseapp.com",
    databaseURL: "https://contadoresrv-8b2d4.firebaseio.com",
    projectId: "contadoresrv-8b2d4",
    storageBucket: "contadoresrv-8b2d4.appspot.com",
    messagingSenderId: "737866895056",
    appId: "1:737866895056:web:d3115a11badfa550be58d5",
  },
  firestore: {
    // Custom Firestore database ID (not "(default)")
    databaseId: "contadoresrv-db",
    // Prefijo en local / `ng build --configuration development`: colecciones
    // `dev-bills`, `dev-clients`, … En prod (`environment.prod.ts`) va vacío →
    // `bills`, `clients`. Misma base de datos; en la consola Firebase filtrá
    // por el nombre de colección que corresponda al build.
    collectionPrefix: "dev-",
  },
};
